import resolver, {ResolverSettings} from './utils/resolver';

class DocumentsApi {
  ENDPOINTS = {
    contracts: (params = '') => `documents/contracts/?${params}`,
    documentsPrivacyPolicy: (housingId: string) =>
      `documents/privacy-policy-settings/${housingId}/`,
  };

  getContracts(params = '', resolverSettings?: ResolverSettings) {
    return resolver(
      this.ENDPOINTS.contracts(params),
      {method: 'GET'},
      {version: 'v3', ...resolverSettings},
    );
  }

  getPrivacyPolicy(id: string, resolverSettings?: ResolverSettings) {
    return resolver(
      this.ENDPOINTS.documentsPrivacyPolicy(id),
      {method: 'GET'},
      {version: 'v3', ...resolverSettings},
    );
  }
}

export {DocumentsApi};
